import {
    ChangeDetectionStrategy,
    Component,
    Input,
    EventEmitter,
    Output,
    OnChanges,
    SimpleChanges,
    TrackByFunction,
    TemplateRef
} from '@angular/core';
import { ProjectsListProjectGetRecordsList } from '@nx-customer-apps/api-planning-projects';
import { ConfirmConfig, Column, ListOrder, OrderType } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ListComponent implements OnChanges {
    public readonly orderType = OrderType;
    public displayedColumns: string[] | undefined = [];

    @Output() public rowClick: EventEmitter<any> = new EventEmitter();
    @Output() public orderChange: EventEmitter<ListOrder> = new EventEmitter();

    @Input() public columns: Column[];
    @Input() public data: any[];
    @Input() public pointer: boolean;
    @Input() public deleteConfirmConfig: ConfirmConfig;
    @Input() public order: ListOrder | null;
    @Input() public trackByFn: TrackByFunction<ProjectsListProjectGetRecordsList> = (index, project) => project.id;
    @Input() public contextMenuTemplateRef?: TemplateRef<any> | undefined;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['columns']?.currentValue) {
            this.displayedColumns = this.columns.map(column => column.name);
        }
    }

    public onOrderChange(orderBy: string, orderType?: OrderType): void {
        switch (orderType) {
            case OrderType.Desc:
                this.orderChange.emit({});
                break;

            case OrderType.Asc:
                this.orderChange.emit({ orderBy, orderType: OrderType.Desc });
                break;

            default:
                this.orderChange.emit({ orderBy, orderType: OrderType.Asc });
                break;
        }
    }

    public getRowClasses(row: any): { [klass: string]: boolean } {
        const classes: { [key: string]: boolean } = {
            'cursor-pointer': this.pointer,
            'mat-row-non-clickable': !this.pointer
        };

        this.columns
            .filter(c => typeof c.rowClass === 'function')
            .forEach(c => {
                const result = c.rowClass!(row);
                if (typeof result === 'string') {
                    classes[result] = true;
                } else if (Array.isArray(result)) {
                    result.forEach(cls => (classes[cls] = true));
                }
            });

        return classes;
    }
}
